export default {
    setUserMessage: '/api/web/v2/account/setusermessage',
}